import { Flyer } from './GetFlyers';
import { Location } from './GetUserPreferences';
import { PaginationOptions } from './Pagination';

export enum OwningTypeEnum {
  district = 'district', //For School or district flyers
  organization = 'organization', //For community flyers
}

export enum FlyerboardTimeFrame {
  ThisWeek = 'ThisWeek',
  LastWeek = 'LastWeek'
}

export type AllFlyerFilters = {
  owningType?: OwningTypeEnum;
  schoolIds: Number[];
  districtId?: Number;
  categories?: String[];
  searchQuery?: String;
  format?: String;
  allDistrictSchools?: Boolean;
  isCommunityFree?: Boolean;
  isDistrictWidePosting?: Boolean;
  isNew?: Boolean;
  grades?: String[];
  gradesOrAges?: String[];
  isNewAndUnread?: Boolean;
  isExpired?: Boolean;
  isFavorite?: Boolean;
  totalOnly?: Boolean;
  isRemoved?: Boolean;
  isInMySchool?: Boolean;
  communityLocation?: Location;
  communityRadius?: number;
  newFlyerboardTimeFrame?: FlyerboardTimeFrame;
};

export type Facet = {
  key: String;
  count: number;
};

export type Facets = {
  categories: Facet[];
  gradesOrAges: Facet[];
};

export type FlyerCardThumbnail = Pick<
  Flyer,
  | 'flyerId'
  | 'startDate'
  | 'endDate'
  | 'submittedAt'
  | 'districtId'
  | 'title'
  | 'status'
  | 'frontImageUrl'
  | 'isFavorite'
  | 'isRead'
  | 'gradesOrAges'
  | 'criticalDate'
  | 'categories'
  | 'type'
  | 'minTargetGradeOrAge'
  | 'maxTargetGradeOrAge'
  | 'schoolCount'
  | 'pages'
  | 'email'
  | 'isExpandedCommunity'
  | 'titleTranslations'
> & {
  org?: {
    name: string;
  };
};

export type GetAllFlyersResponse = {
  getAllFlyers: {
    items: FlyerCardThumbnail[];
    pagination: PaginationOptions;
  };
};

export type GetFacetsResponse = {
  getFacets: {
    facets: Facets;
    pagination: {
      total: number;
    };
  };
};

export type GetAllFlyersInput = {
  filters: AllFlyerFilters;
  pagination: {
    pageNumber: number;
    pageSize: number;
  };
  sort?: {
    sortBy: string;
  };
};

export type GetAllFlyersVars = {
  input: GetAllFlyersInput;
};
